export default __webpack_public_path__ + "pdf/David_Goodsell.ec2b69d.pdf";